// extracted by mini-css-extract-plugin
module.exports = {"clock":"clock__R1_R1","clock--6":"clock--6__1Mc1E"};